import { memo } from 'react';

import { usePathname } from 'next/navigation';

import { Entry } from 'contentful';

import { ExtendedProductFields } from '@/core/contentfulConfig';
import { FeatureFlag } from '@/core/featureFlags';

import useFeature from '@/hooks/useFeature';

import { getProductInventoryStatus } from '@/lib/shopify';

import OfferSchema from './OfferSchema';
import { buildProductUrl } from './productUrl';

export interface ProductSchemaProps {
  product: Entry<ExtendedProductFields>;
  url?: string; // Required when appearing outside of a product page
}

const ProductSchema = ({ product, url }: ProductSchemaProps) => {
  const pathname = usePathname();

  const pufDiscountPlayKitPdp =
    useFeature(FeatureFlag.MONEY_PUF_DISCOUNT_PLAY_KIT_PDP) || 'off';

  const imageUrl = product.fields.featuredImage?.fields.Image?.fields.file?.url;

  const productUrl = url || buildProductUrl(pathname);

  const shopifyProduct = product.fields.shopifyProduct;
  const variant = shopifyProduct?.variants[0];
  const inventoryStatus = shopifyProduct
    ? getProductInventoryStatus(shopifyProduct, variant)
    : null;

  return (
    <div>
      <meta itemProp="name" content={product.fields.title} />
      <meta itemProp="url" content={productUrl} />
      <meta itemProp="brand" content="Lovevery" />
      <meta itemProp="image" content={imageUrl} />
      <meta itemProp="description" content={product.fields.shortDescription} />

      {variant && (
        <OfferSchema
          variant={variant}
          url={productUrl}
          isPlayKit={product.fields.isPlayKit}
          pufDiscountPlayKitPdp={pufDiscountPlayKitPdp}
          ageRange={product.fields.ageRange}
          inventoryStatus={inventoryStatus}
        />
      )}
    </div>
  );
};

export default memo(ProductSchema);
